var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentationChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C2 2.44772 2.44772 2 3 2H17C17.5523 2 18 2.44772 18 3C18 3.55228 17.5523 4 17 4V12C17 13.1046 16.1046 14 15 14H12.844L13.9578 16.7127C14.1165 17.2417 13.8163 17.7991 13.2873 17.9578C12.7583 18.1165 12.2009 17.8164 12.0422 17.2874L10.756 14H9.24403L7.95781 17.2874C7.79912 17.8164 7.24163 18.1165 6.71264 17.9578C6.18365 17.7991 5.88346 17.2417 6.04216 16.7127L7.15596 14H5C3.89543 14 3 13.1046 3 12V4C2.44772 4 2 3.55228 2 3ZM8 8C8 7.44772 7.55228 7 7 7C6.44772 7 6 7.44772 6 8V10.5C6 11.0523 6.44772 11.5 7 11.5C7.55228 11.5 8 11.0523 8 10.5V8ZM10 6C10.5523 6 11 6.44772 11 7V10.5C11 11.0523 10.5523 11.5 10 11.5C9.44772 11.5 9 11.0523 9 10.5V7C9 6.44772 9.44772 6 10 6ZM14 6C14 5.44772 13.5523 5 13 5C12.4477 5 12 5.44772 12 6V10.5C12 11.0523 12.4477 11.5 13 11.5C13.5523 11.5 14 11.0523 14 10.5V6Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentationChart);
export default __webpack_public_path__ + "static/media/presentation-chart.d6d77cfa092cc32decd130385aff988a.svg";
export { ForwardRef as ReactComponent };